<template>
  <div>
    <p class="has-text-default has-text-weight-bold">
      {{ $t(title) }}
    </p>
    <b-autocomplete icon="magnify" v-model="searchCommentaire"
                    class="mgt-5px"
                    :data="dataAutoCompleteComment" field="libelle"
                    @select="commentaire => selectCommentaire(commentaire)"
                    @input="getCommentData"
                    @focus="getCommentData"
                    open-on-focus
                    :placeholder="$t('commentaire.actions.search')">
      <template slot="header">
        <a @click="checkPermissions(permsCommentaire.maj)
              ? openPopUpAjoutEditCommentaire = true : showPopUp()"
           class="lien" :class="{ 'text-access-no-permission' :
                   !checkPermissions(permsCommentaire.maj)}">
          <span> {{$t('commentaire.actions.add')}} </span>
        </a>
      </template>
      <template slot="empty"> {{$t('commentaire.actions.noResult')}} </template>
    </b-autocomplete>
    <b-input class="mgt-10px" type="textarea"
             rows="6"
             @input="$emit('input', inputComment)"
             v-model="inputComment">
    </b-input>
    <b-modal v-model="openPopUpAjoutEditCommentaire"
             has-modal-card
             class="modal">
      <pop-up-add-edit-commmentaire
        @reloadCommentaire="selectCommentaire">
      </pop-up-add-edit-commmentaire>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import { COMMENTAIRE } from '@/configuration/general/permissionsParametrageConf';
import popUpAddEditCommmentaire from '@/components/parametrage/commentaire/p_addEditCommentaire';

const permissions = createNamespacedHelpers('permissions');

export default {
  name: 'GeneralCommentaire',
  props: {
    title: {
      type: String,
      required: true,
    },
    value: {
      required: true,
    },
    commentaires: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      inputComment: '',
      searchCommentaire: '',
      dataAutoCompleteComment: [],
      openPopUpAjoutEditCommentaire: false,
      permsCommentaire: COMMENTAIRE,
    };
  },
  components: {
    popUpAddEditCommmentaire,
  },
  watch: {
    value() {
      this.inputComment = this.value;
    },
  },
  computed: {
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
  },
  methods: {
    ...permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    selectCommentaire(commentaire) {
      if (!commentaire) return;
      this.searchCommentaire = commentaire.libelle;
      this.inputComment = commentaire.message;
      this.$emit('input', this.inputComment);
    },
    getCommentData() {
      this.dataAutoCompleteComment = this.commentaires.filter(commentaire => {
        return commentaire.libelle.toLocaleLowerCase()
          .includes(this.searchCommentaire.toLocaleLowerCase());
      });
    },
  },
  mounted() {
    this.inputComment = this.value;
  },
};

</script>
